function isRecommended(planId: number, state: Pivot.State) {
  const recommendDurations = state.recommendDurations ?? {}

  const result = recommendDurations[planId]

  return result
}
export default isRecommended
